
import React from 'react'

import { GridStepper } from '@front/squirtle'

import { Box, Grid, Step } from '@mui/material'

import Dashboard from '@abra/panels/Dashboard'
import FormHeader from '@abra/elements/headers/Form'
import CompanyTab from '@abra/panels/Tab/Company'
import OrderLimitationSection from '@abra/panels/OrderLimitation'

import Popups from './Popup'
import PrimarySection from './Section/Primary'
import ContactsSection from './Section/Contacts'
import VoucherSection from './Section/Voucher'
import CompanyTemplateSection from './Section/CompanyTemplate'

const Company = ({ getStepProps, record_id, VOUCHER_ENABLED }) =>
  <>
    <Popups />
    <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
      <Grid container rowSpacing={3}>
        <Grid size={12}><CompanyTab value={1} /></Grid>
        <Grid size={12}><FormHeader goBackPath={'/company'} /></Grid>
        <Grid size={12}>
          <GridStepper
            groupsCount={[6]}
            activeStep={0}
            orientation="vertical"
            getStepProps={getStepProps}
          >
            <Step><PrimarySection /></Step>
            {VOUCHER_ENABLED && <Step><VoucherSection /></Step>}
            <Step><ContactsSection /></Step>
            <Step><OrderLimitationSection model='companyorderlimit' company={record_id} /></Step>
            <Step><CompanyTemplateSection /></Step>
            <Dashboard company_id={record_id} />
          </GridStepper>
        </Grid>
      </Grid>
    </Box>
  </>

export default React.memo(Company)
